"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FadeInDown = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./FadeInDown.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * EXPERIMENTAL: This component is experimental and should be used internally only.
 */
const FadeInDown = _ref => {
  let {
    children,
    className,
    isVisible
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("fade-in--down", className),
    "aria-hidden": isVisible ? "false" : "true",
    style: {
      visibility: isVisible ? "visible" : "hidden"
    }
  }, children);
};
exports.FadeInDown = FadeInDown;
FadeInDown.propTypes = {
  isVisible: _propTypes.default.bool.isRequired,
  className: _propTypes.default.string
};